import { useEffect, useState, useRef } from 'react';
import {
  Box,
  TextField,
  Card,
  CardContent,
  CardHeader,
  Container,
  Grid,
  Button,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Checkbox,
  ListItemText,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import AWS from 'aws-sdk';
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';

AWS.config.update({
  accessKeyId: 'YOUR_ACCESS_KEY',
  secretAccessKey: 'YOUR_SECRET_KEY',
  region: 'ap-south-1',
});

const EditNotification = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const quillRef = useRef(null);
  const [receiver, setReceiver] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState('');
  const [img, setImg] = useState('');
  const [submitData, setSubmitData] = useState(false);
  const [receiverErr, setReceiverErr] = useState(false);
  const [subnotification, setSubNotification] = useState('');
  const [membersIds, setMemberIds] = useState([]);
  const [notificationData, setNotificationData] = useState([]);

  const handleData = async () => {
    console.log(membersIds, "3222222222222");

    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/notifications/getnotification/${id}`);
      setTitle(data.Title);
      setSubNotification(data.SubNotification);
      setReceiver(data.Receiver);
      setContent(data.Content);
      setDescription(data.Description);
      setImage(data.image);
      setMemberIds(data.membersIds.map(member => member.member)); // Map member IDs to set initial selection
    } catch (error) {
      console.log('Error fetching data:', error);
    }
  };

  useEffect(() => {
    handleData();
    handleNotificationData(); // Fetch members data when component mounts
  }, []);

  const handleNotificationData = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/members/getAll`);
      setNotificationData(data);
    } catch (error) {
      console.error(error);
    }
  };

  const s3 = new AWS.S3();

  const handleImageFile = async (e) => {
    const file = e.target.files[0];
    const folderPath = 'community1/';

    if (file) {
      const params = {
        Bucket: 'chaturvedi-v2',
        Key: `${folderPath}${Date.now()}_${file.name}`,
        Body: file,
        ACL: 'public-read',
        ContentType: file.type
      };

      try {
        const { Location } = await s3.upload(params).promise();
        setImg(Location);
        setImage(Location);
      } catch (error) {
        toast.error(error.message, { position: 'bottom-right' });
      }
    }
  };

  const handleEdit = async () => {
    // console.log(memberIds,"122222222222");
    const selectedMembersIds = membersIds;
    const members = selectedMembersIds.map((data) => ({
      member: data
    }));

    if (!receiver) {
      setReceiverErr(true);
      return;
    }

    setSubmitData(true);

    try {
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/notifications/update/${id}`, {
        Receiver: receiver,
        Title: title,
        Content: content,
        Description: description,
        SubNotification: subnotification,
        image: img || image,
        ...(receiver === 'Member' && { membersIds: members })
      });
      toast.success('Announcement updated successfully!', { position: 'bottom-right' });
      navigate('/notifications');
    } catch (error) {
      setSubmitData(false);
      toast.error(error.response?.data?.message || 'Error updating announcement', { position: 'bottom-right' });
    }
  };

  console.log(notificationData, "rrr");


  return (
    <Container maxWidth="lg" sx={{ mt: 2 }}>
      <Grid container justifyContent="center">
        <Grid item xs={12}>
          <Card>
            <CardHeader
              title="Edit Notification"
              titleTypographyProps={{
                style: {
                  margin: 10,
                  color: '#000',
                  fontWeight: 700,
                  fontSize: '25px',
                  marginBottom: '30px'
                }
              }}
            />
            <CardContent>
              <Box component="form" noValidate autoComplete="off">
                <InputLabel htmlFor="receiver" sx={{ mb: 1 }}>Receiver</InputLabel>
                <Select
                  id="receiver"
                  value={receiver || ''}
                  onChange={(e) => {
                    setReceiver(e.target.value);
                    setReceiverErr(false);
                  }}
                  sx={{ mb: 2, width: '100%' }}
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Member">Member</MenuItem>
                </Select>
                {receiverErr && <span style={{ color: 'red' }}>Receiver is required</span>}

                <TextField
                  id="title"
                  label="Title"
                  value={title || ''}
                  onChange={(e) => {
                    setTitle(e.target.value);
                  }}
                  sx={{ mb: 2, width: '100%' }}
                />
                <TextField
                  id="description"
                  label="Push Notification Description"
                  value={description || ''}
                  onChange={(e) => setDescription(e.target.value)}
                  sx={{ mb: 2, width: '100%' }}
                />

                <InputLabel shrink htmlFor="Description" style={{ marginBottom: 4 }}>
                  Detailed Description
                </InputLabel>
                <ReactQuill
                  ref={quillRef}
                  value={content}
                  onChange={(value) => {
                    setContent(value);
                  }}
                  placeholder="Add Content"
                  modules={{
                    toolbar: [
                      [{ bold: true }, { italic: true }],
                      [{ list: 'ordered' }, { list: 'bullet' }],
                      [{ header: [1, 2, false] }],
                      [{ color: [] }],
                      ['link'],
                    ],
                  }}
                  formats={['bold', 'italic', 'list', 'header', 'color', 'link']}
                  style={{ marginBottom: '20px', width: '100%' }}
                />

                <InputLabel htmlFor="subNotification" sx={{ mb: 1 }}>Select Type of Notification</InputLabel>
                <Select
                  id="subNotification"
                  sx={{ width: '100%', mb: 2 }}
                  value={subnotification}
                  onChange={(e) => setSubNotification(e.target.value)}
                >
                  <MenuItem value="General">General</MenuItem>
                  <MenuItem value="Important">Important</MenuItem>
                  <MenuItem value="Government">Government</MenuItem>
                  <MenuItem value="Personal">Personal</MenuItem>
                </Select>

                {receiver === 'Member' && (
                  <div style={{ margin: '9px 0', width: '33.33%' }}>
                    <InputLabel htmlFor="members" sx={{ mb: 1 }}>Members</InputLabel>
                    <Select
                      id="membersIds"
                      multiple
                      value={membersIds}
                      onChange={(event) => {
                        const { value } = event.target;
                        console.log(event.target, "3222222222222");

                        setMemberIds(typeof value === 'string' ? value.split(',') : value);
                      }}
                      renderValue={(selected) => (
                        <div>
                          {selected.map((id) => {
                            const selectedMember = notificationData.find(member => member._id === id);
                            return (
                              <Typography key={id} variant="body2">
                                {/* {selectedMember?.name}
                                 */}
                                {`${selectedMember?.name}/${selectedMember?.area}/${selectedMember?.familyId}`}
                              </Typography>
                            );
                          })}
                        </div>
                      )}
                      sx={{ width: '100%', mb: 2 }}
                    >
                      {notificationData.map((member) => (
                        <MenuItem key={member._id} value={member._id}>
                          <Checkbox checked={membersIds.indexOf(member._id) > -1} />
                          <ListItemText primary={`${member.name}/${member.area}/${member.familyId}`} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                )}

                <input type="file" onChange={handleImageFile} style={{ marginBottom: '20px' }} />
                {image && <img src={image} alt="Uploaded" style={{ maxWidth: '100%', marginTop: '10px' }} />}

                <Box mt={2} display="flex">
                  <Button onClick={handleEdit} disabled={submitData} variant="contained" sx={{ mr: 2 }}>
                    Submit
                  </Button>
                  <Button onClick={() => navigate('/notifications')} variant="outlined">
                    Back to Notifications
                  </Button>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default EditNotification;
